import { Cirus } from "@/classes/Http";

class Option {
    value: string;
    id: string;
    category_filter_id: string;
}

enum CategoryFilterType {
    TEXT = "text",
    SELECT = "select",
    NUMBER = "number",
    BOOLEAN = "boolean",
    COLOR = "color",
    RATING = "rating",
    IMAGE = "image"
}

export class UpdateCategoryFilterBody {
    id: string;
    name: string;
    type: CategoryFilterType;
    group_id: string = null;
    options: Option[];
}

export function updateCategoryFilter(instance_id: number, category_id: string, params: UpdateCategoryFilterBody) {
    const path = `/instance/${instance_id}/category/${category_id}/filter`;
    return Cirus.post(path, params);
}